import m from 'mithril';
import {trans} from "../helpers";

var Prosemirror = require("../prosemirror/index");
let challenge_state = require('../new_challenge_creator/challengeState.js');

let content_parser_interval = null;

let unsaved_changes = false;

class ContentEditorComponent {
    oncreate() {
        challenge_state.exercise_editor_state.editor = Prosemirror.init('#contentEditor', '#content', 'exercise', challenge_state.exercise_editor_state.id_exercise);

        content_parser_interval = setInterval(e => { this.parseCustomTags('#contentEditor') }, 500);

        challenge_state.exercise_editor_state.exercise.content = this.parseToCustom();
    }

    parseToCustom() {
        let content_str = challenge_state.exercise_editor_state.editor.dom.innerHTML;

        content_str = this.replaceElementContent(content_str, 'ct-video', '');
        content_str = this.replaceElementContent(content_str, 'ct-image', '');

        return content_str;
    }

    parseCustomTags(containerSelector) {
        let container = document.querySelector(containerSelector);
        
        this.parseCtVideo(container);
        this.parseCtImage(container);
    }

    parseCtImage(container) {
        let images = container.querySelectorAll('ct-image');

        images.forEach(image => {
            let status = image.getAttribute("status");
            let uploading = image.getAttribute("uploading");
            
            let id_image = image.getAttribute("id_image");

            let img_src = (id_image in challenge_state.exercise_editor_state.images_cache) ? challenge_state.exercise_editor_state.images_cache[id_image] : false;

            if (status == 'parsed' && id_image && !img_src) {
                m.request({
                    method: "GET",
                    url: "/api/media/get_image/"+id_image,
                }).then(function(data) {
                    if (data.status == 200) {
                        challenge_state.exercise_editor_state.images_cache[id_image] = data.image.public_url;

                        if (!data.image.public_url) {
                            if (uploading != 'true') {
                                image.setAttribute('uploading', 'true');
                                m.mount(image, { view: () => m(ImageLoader) });
                                m.redraw();
                            }
                        }
                    }
                });
            }

            if (status == 'parsed' && img_src) {
                status = 'rendered';
                
                image.setAttribute('status', 'rendered');
                m.mount(image, { view: () => m(CtImage, {src: img_src}) });

                return;
            }

            if (status == 'parsed' || status == 'rendered') 
                return;

            image.setAttribute('status', 'parsed');

            m.mount(image, { view: () => m(Loader) });
        });
    }

    parseCtVideo(container) {
        let videos = container.querySelectorAll('ct-video');

        videos.forEach(video => {
            let status = video.getAttribute("status");
            let uploading = video.getAttribute("uploading");
            
            let id_video = video.getAttribute("id_video");

            let video_src = (id_video in challenge_state.exercise_editor_state.videos_cache && challenge_state.exercise_editor_state.videos_cache[id_video].src) ? challenge_state.exercise_editor_state.videos_cache[id_video].src : false;

            if ((status == 'parsed' && id_video && !video_src) || status == 'procesing') {
                m.request({
                    method: "GET",
                    url: "/api/media/get_video/"+id_video,
                }).then(function(data) {
                    if (data.status == 200) {
                        challenge_state.exercise_editor_state.videos_cache[id_video] = {
                            src: data.video.id_stream,
                            status: data.video.status
                        };

                        if (data.video.status != 'uploading_service' && data.video.status != 'processed') {
                            if (uploading != 'true') {
                                video.setAttribute('uploading', 'true');
                                let progress = video.dataset.progress;
                                m.mount(video, { view: () => m(VideoLoader, {progress: progress}) });
                            }
                        }
                    }
                });
            }

            let video_status = id_video in challenge_state.exercise_editor_state.videos_cache ? challenge_state.exercise_editor_state.videos_cache[id_video].status : 'und';

            if (status == 'parsed' && (video_status == 'uploading_service' || video_status == 'processed' || video_status == 'error')) {
                status = 'procesing';
                video.setAttribute('status', status);

                m.mount(video, { view: () => m(VideoProcessing) });
            }


            if (status == 'procesing' && (video_status == 'processed' || video_status == 'error')) {
                status = 'rendered';
                video.setAttribute('status', status);

                if (video_status == 'error') {
                    // TODO: HANDLE ERROR!
                }

                m.mount(video, { view: () => m(CtVideo, {src: video_src, id_video: id_video}) });

                return;
            }

            if (status == 'parsed' || status == 'procesing' || status == 'rendered') 
                return;

            video.setAttribute('status', 'parsed');

            m.mount(video, { view: () => m(Loader) });
            // m.mount(video, { view: () => m(VideoLoader) });
            // m.mount(video, { view: () => m(VideoProcessing) });
        });
    }

    replaceElementContent(html, element, replace_with) {
        let element_begin = "<" + element;
        let element_end = "</" + element + ">";

        let i1 = html.indexOf(element_begin);

        html = html.replace('contenteditable="false"', '');
        html = html.replace('draggable="true"', '');
        html = html.replace('status="rendered"', '');
        html = html.replace('status="parsed"', '');


        while (i1 != -1) {
            i1 = html.indexOf(">", i1+1)+1;

            let i2 = html.indexOf(element_end, i1+1); 
            let to_replace = html.substring(i1, i2);

            html = html.replace(to_replace, replace_with);

            i1 = html.indexOf(element_begin, i1 +1);
        }

        html = html.replace(/  +/g, ' ')

        return html;
    }


    getStateString(html) {
        let state_string = '';
        
        var htmlObject = document.createElement('div');
        htmlObject.innerHTML = html;

        let videos = htmlObject.querySelectorAll('ct-video');

        let id_videos = [];

        videos.forEach(video => {
            let id_video = video.getAttribute("id_video");
            id_videos.push(id_video);
        });

        let images = htmlObject.querySelectorAll('ct-image');

        let id_images = [];

        images.forEach(image => {
            let id_image = image.getAttribute("id_image");
            id_images.push(id_image);
        });

        let compare_numbers_asc = (a, b) => a - b;

        id_videos.sort(compare_numbers_asc);
        id_images.sort(compare_numbers_asc);

        let videos_str = id_videos.reduce((str, id_video) => str + 'V' + id_video, '');
        let images_str = id_images.reduce((str, id_image) => str + 'I' + id_image, '');

        state_string = videos_str + images_str;

        return state_string;
    }

    view() {
        let content = challenge_state.exercise_editor_state.exercise != null ? challenge_state.exercise_editor_state.exercise.content : '';

        return [
            m('#contentEditor.contentEditor--dark-theme'),
            m('#content', {style: 'display: none;'}, m.trust(content))
        ]
    }
}


class Loader {
    view(vnode) {
        return m('.video-loader', 
            m('.general-loader', '')
            // m('.loader.icon-spin', [
            //     m('svg', 
            //         {
            //             xmlns: "http://www.w3.org/2000/svg",
            //             viewBox: "0 0 512 512"
            //         },
            //         [
            //             m('path', {
            //                 d: "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
            //             })
            //         ]
            //     )
            // ]),
        );
    }
}

class ImageLoader {
    view(vnode) {
        return m('.video-loader', 
            m('.video-loader__text-container', [
                m('.video-loader__text', trans('exercises.content_editor.image_is_uploading_text')),
                m('.video-loader__text', trans('exercises.content_editor.dont_close_editor_text')),
            ]),
            m('.general-loader', '')
            // m('.loader.icon-spin', [
            //     m('svg', 
            //         {
            //             xmlns: "http://www.w3.org/2000/svg",
            //             viewBox: "0 0 512 512"
            //         },
            //         [
            //             m('path', {
            //                 d: "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
            //             })
            //         ]
            //     )
            // ]),
        );
    }
}

class VideoLoader {
    view(vnode) {
        // console.log("progress", vnode.attrs.progress);
        // if (typeof vnode.dom != "undefined") {
        //     let parent = vnode.dom.parentElement;
        //     let progress = parent.dataset.progress;

        //     console.log("progress", progress);
        // }

        let progress = vnode.attrs.progress;

        return m('.video-loader', 
            m('.video-loader__text-container', [
                m('.video-loader__text', trans('exercises.content_editor.video_is_uploading_text')),
                m('.video-loader__text', trans('exercises.content_editor.dont_close_editor_text')),
            ]),
            m('.general-loader', ''),
            m('.video-loader__percent-container', ''),
            // m('.loader.icon-spin', [
            //     m('svg', 
            //         {
            //             xmlns: "http://www.w3.org/2000/svg",
            //             viewBox: "0 0 512 512"
            //         },
            //         [
            //             m('path', {
            //                 d: "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
            //             })
            //         ]
            //     )
            // ])
        );
    }
}


class VideoProcessing {
    view(vnode) {
        return m('.video-loader', 
            m('.video-loader__text-container .video-loader__text-container--no-margin', [
                m('.video-loader__text', trans('exercises.content_editor.video_uploded_text')),
                m('.video-loader__text', trans('exercises.content_editor.video_uploded_subtext')),
            ]),
        );
    }
}


class CtImage {
    view(vnode) {
        return[
            m('img', {
                style: "max-width:100%; height:auto",
                src: vnode.attrs.src
            })
        ];
    }
}

class CtVideo {
    oncreate(vnode) {
        jwplayer('jw-video-' + vnode.attrs.id_video).setup({
            "file": "https://videodelivery.net/" + vnode.attrs.src + "/manifest/video.m3u8",
            "image": "https://videodelivery.net/" + vnode.attrs.src + "/thumbnails/thumbnail.jpg?width=800",
            "logo": false
        });
    }

    view(vnode) {
        return[
            m('.video16_9__player', { id: 'jw-video-' + vnode.attrs.id_video })
            // m('stream', {
            //     src: vnode.attrs.src,
            //     controls: true,
            // }),
            // m('script', {
            //     'data-cfasync': "false",
            //     defer: true,
            //     type: "text/javascript",
            //     src: "https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=" + vnode.attrs.src
            // })
        ];
    }
}

class EditExerciseContent {
    oninit() {
        challenge_state.exercise_editor_state = challenge_state.get_empty_exercise_editor_state();

        if ('id_exercise' in challenge_state.new_exercise)
            challenge_state.exercise_editor_state.id_exercise = challenge_state.new_exercise.id_exercise;

        this.get_exercise()
    }
    
    oncreate() {
        this.initial_content = '';

        window.onbeforeunload = e => {
            if (!this.hasChanges()) {
                return undefined;
            }

            return "unsaved changes!"; // ADD TO TRANSLATIONS!
        };
    }

    hasChanges() {
        let content_editor = new ContentEditorComponent();
        let current_content = content_editor.parseToCustom();

        let initial_state_string = content_editor.getStateString(this.initial_content);
        let current_state_string = content_editor.getStateString(current_content);

        return initial_state_string != current_state_string;
    }

    get_exercise() {
        if (!('id_exercise' in challenge_state.exercise_editor_state))
            return

        m.request({
            method: "GET",
            url: "/api/exercises/"+challenge_state.exercise_editor_state.id_exercise
        }).then(data => {
            challenge_state.exercise_editor_state.exercise = data;

            this.initial_content = challenge_state.exercise_editor_state.exercise.content;
        });
    }

    go_back(e) {
        if (content_parser_interval != null)
            clearInterval(content_parser_interval);

        challenge_state.current_step = 'select_exercises';
    }

    saveExercise(e) {
        let content_editor = new ContentEditorComponent();

        challenge_state.exercise_editor_state.exercise.content = challenge_state.exercise_editor_state.editor.dom.innerHTML;
        challenge_state.exercise_editor_state.exercise.content = content_editor.parseToCustom();

        challenge_state.exercise_editor_state.exercise['return_model'] = true

        challenge_state.exercise_loading = true;

        m.request({
            method: "POST",
            url: "/api/exercises/"+challenge_state.exercise_editor_state.id_exercise,
            responseType: "json",
            body: challenge_state.exercise_editor_state.exercise
        }).then(data => {
            if (content_parser_interval != null) {
                clearInterval(content_parser_interval);
            }

            console.log(data);

            this.initial_content = challenge_state.exercise_editor_state.exercise.content;

            challenge_state.exercise_loading = false;

            // EXERCISE IS UPDATED THROUGH CHALLENGE EDITOR, WE NEED TO SAVE TO CHALLENGE STATE SO IT CAN BE IMMEDIATELY USED IN CHALLENGE 
            if (challenge_state.mode == 'insert' || challenge_state.mode == 'update') {
                challenge_state.challenge.exercises = [];

                let exercise = data.data;
                exercise['inserted_at'] = new Date(exercise['inserted_at']).toLocaleDateString("sl-SI");

                challenge_state.challenge.exercises.push(exercise);
                
                challenge_state.current_step = 'select_exercises';
            }

            if (challenge_state.mode == 'insert_exercise' || challenge_state.mode == 'update_exercise') {
                challenge_state.current_step = 'exercise_created';
            }
        }).catch(e => {
            if (e.response && e.response.error && e.response.error.description) {
                alert(e.response.error.description);
            } else {
                alert('Trouble saving exercise');
            }
        });
    }

    view(){
        return [
            (challenge_state.mode != 'insert' && challenge_state.mode != 'update') &&
            m('h2.editor-title', trans('challenge.creating_exercise_content_title')),

            (challenge_state.mode == 'insert' || challenge_state.mode == 'update') && // ONLY THROUGH CHALLENGE EDITOR
            m('.create-exercise-header', [
                m('h2.editor-title', trans('challenge.creating_exercise_content_title')),

                m('.link', {
                    onclick: e => this.go_back(e)
                }, trans('challenge.go_back_btn')),
            ]),

            challenge_state.exercise_editor_state.exercise &&
            m('.ijf-form', [
                m('.line.line--no-margin', [
                    m('.line-element.line-element--inline', [
                        m('label', trans('exercises.form.title') + ':'),
                        m('div.entered-data', challenge_state.exercise_editor_state.exercise.title)
                    ]),
                ]),
                
                m('.line.line--no-margin', [
                    m('.line-element.line-element--inline', [
                        m('label', trans('exercises.form.short_description') + ':'),
                        m('div.entered-data', challenge_state.exercise_editor_state.exercise.short_description)
                    ]),
                ]),
                
                m('.contentEditorContainer', [
                    m('label.form-label', trans('exercises.form.content')),

                    m('div.form-helper', [
                        m('span', trans('challenge.content_editor_helper')),
                        m('span', trans('challenge.content_editor_helper.steps_of_exercise') + ' '),
                        m('span', m('img', {width: "20", height: "20", src: "/imgs/editor_icons/content-editor_list-icon.png"})),
                        m('span', ', ' + trans('challenge.content_editor_helper.upload_image') + ' '),
                        m('span', m('img', {width: "20", height: "20", src: "/imgs/editor_icons/content-editor_image-icon.png"})),
                        m('span', ' ' + trans('challenge.content_editor_helper.upload_video') + ' '),
                        m('span', m('img', {width: "20", height: "20", src: "/imgs/editor_icons/content-editor_video-icon.png"})),
                        m('span', ' .'),
                    ]),

                    m(ContentEditorComponent)
                ]),

                challenge_state.exercise_loading &&
                m('.general-loader', ''),

                !challenge_state.exercise_loading &&
                m('.line.line--center', 
                    m('.btn.btn--full-width.btn--main', {
                        type: 'submit',
                        onclick: e => this.saveExercise(e)
                    }, trans('exercises.save_btn'))
                )
            ])
        ]
    }
}

export default EditExerciseContent;